// Call a require based helper to select platform to export
export { setPathPrefix, loadFile, loadImage } from './browser-load';
export { loadFiles, loadImages, loadTextures } from './load-files';
export { loadProgram, loadModel, parseModel } from './load-files';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/io/index.js
// module id = 1561
// module chunks = 0